import { AppEvent, EventBusInstance, Modal, ModalType } from '@sprint/sprint-react-components';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import LimitIssue from '../../Models/LimitIssue';
import './LimitReachedModal.scss';
declare function dictionaryValue(key: string): string;

interface Props {
    uniqueKey: string;
    limitNameSingular: string;
    limitNamePlural: string;
}

const MultipleLimitReachedModal: FunctionComponent<Props> = (props: Props) => {
    // State: General
    const [shown, setShown] = useState<boolean>(false);
    const [limitIssues, setLimitIssues] = useState<LimitIssue[]>([]);

    useEffect(() => {
        EventBusInstance.subscribe('show-hoverover-component', (event: AppEvent<LimitIssue[]>) => {
            if (event.target !== props.uniqueKey) return;
            setLimitIssues(event.message);
            setShown(true);
        });
    }, [shown]);

    const supportEmail = dictionaryValue('company.email_support');
    const mailToSupport = `mailto:${supportEmail}`;
    const salesPhoneLine = dictionaryValue('company.telephone_support');

    return (
        <Modal
            className="limit-reached-modal"
            close={() => setShown(false)}
            isOpen={shown}
            title={['You Have Reached Your', props.limitNamePlural, 'Limits'].join(' ')}
            type={ModalType.UPGRADE}
            footerOverride={
                <>
                    <Button
                        variant="primary"
                        onClick={(event) => {
                            event.preventDefault();
                            window.location.href = mailToSupport;
                        }}
                    >
                        Upgrade
                    </Button>
                    <Button variant="default" onClick={() => setShown(false)}>
                        Close
                    </Button>
                </>
            }
        >
            <>
                <ul>
                    {limitIssues.map((limitIssue: LimitIssue) => {
                        return (
                            <li>
                                You are using <strong>{limitIssue.used_count}</strong> out of your plan's{' '}
                                <strong>{limitIssue.limit}</strong> {limitIssue.type}{' '}
                                {props.limitNameSingular.toLowerCase()} limit.
                            </li>
                        );
                    })}
                </ul>
                <p>
                    But, don't worry, it's easy to upgrade!&nbsp;
                    <a href={mailToSupport} className="rdg-link">
                        Click here
                    </a>
                    &nbsp;to compare and upgrade your plan.
                </p>
                <p>
                    Alternatively, give sales a call on <strong>{salesPhoneLine}</strong> or drop us an email at&nbsp;
                    <a href={`mailto:${supportEmail}`} className="rdg-link">
                        {supportEmail}
                    </a>
                </p>
            </>
        </Modal>
    );
};

export default MultipleLimitReachedModal;
